import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { parse } from 'query-string';
import { useRecoilValue } from 'recoil';
import { tokensState } from '../../features/auth';
import { TokensDto, ResponseType } from '@oh-auth/dto/lib';
import { apiClientState } from '../../features/api';

interface AuthorizeProps {
	consented?: string;
	approval_verifier?: string;
	approval_verifier_expired_at?: string;
	approval_challenge?: string;
}

export function Authorize(props: AuthorizeProps) {
	const {
		approval_challenge,
		approval_verifier,
		approval_verifier_expired_at,
		consented,
	} = props;
	const tokens = useRecoilValue(tokensState) as TokensDto;

	const { search } = useLocation();
	const {
		provider_id,
		client_id,
		redirect_uri,
		state,
		nonce,
		scope,
		response_type,
	} = parse(search) as any;
	const apiClient = useRecoilValue(apiClientState);

	useEffect(() => {
		apiClient
			.authorize(tokens, {
				provider_id,
				client_id,
				redirect_uri,
				response_type: response_type as ResponseType,
				state,
				nonce,
				scope,
				approval_challenge,
				approval_verifier,
				approval_verifier_expired_at:
					typeof approval_verifier_expired_at === 'string'
						? parseInt(approval_verifier_expired_at)
						: approval_verifier_expired_at,
				consented:
					typeof consented === 'string'
						? consented === 'true'
						: undefined,
			})
			.then(({ location }) => {
				window.location.replace(location);
			});
	}, [
		apiClient,
		approval_challenge,
		approval_verifier,
		approval_verifier_expired_at,
		client_id,
		consented,
		nonce,
		provider_id,
		redirect_uri,
		response_type,
		scope,
		state,
		tokens,
	]);

	return null;
}
